import { callApiWithoutToken } from './api';

import { ApiResult } from '@/types/api';
import { AttendanceRecord } from '@/types/attendanceRecord';

export const getLineDailyAttendanceRecords = async (
  lineAccessToken: string,
  date: string,
  office_id: number
): Promise<ApiResult<AttendanceRecord[]>> => {
  const searchParams = new URLSearchParams({
    date: date,
    office_id: office_id.toString(),
  });

  const { status, result } = await callApiWithoutToken<AttendanceRecord[]>(
    `line/attendance-records/daily`,
    'GET',
    lineAccessToken,
    searchParams
  );
  return { status, result };
};
